import { Tabs } from 'antd';
import { useTranslation } from 'react-i18next';
import ActivitiesTab from './activitiesTab';
import CustomerTab from './customerTab';
import GeneralTab from './generalTab';
import { observer } from 'mobx-react';
import SalesTab from './salesTab';
import { CustomerSegmentModel } from 'services/Main/customerSegment_services';

type CustomerSegmentDetailProps = {
  customerSegmentationId: string;
  customerSegmentationName: string;
  data?: CustomerSegmentModel;
  onMoveTab: (targetKey: string) => void;
};

function CustomerSegmentDetail(props: CustomerSegmentDetailProps) {
  const { customerSegmentationId, customerSegmentationName, onMoveTab } = props;
  const { t } = useTranslation();


  // xóa chữ DETAIL trong đoạn id, vì có gắn thêm để sửa lại tab hoạt động theo yêu cầu của khách hàng, vui lòng thông cảm
  const idCheckSegment = customerSegmentationId.replace('DETAIL', '')


  return (
    <div className="p-3 border border-gray-300 border-t-0 rounded-b-sm [&_textarea:forcus]:!shadow-none">
      <Tabs
        type="line"
        size={'small'}
        className="[&_.ant-tabs-ink-bar]:!bg-primary"
        items={[
          {
            label: t('segment.tt-chung'),
            key: '1',
            children: (
              <GeneralTab onMoveTab={onMoveTab} data={props.data} customerSegmentationName={customerSegmentationName} customerSegmentationId={customerSegmentationId} />
            ),
          },
          {
            label: t('segment.khach-hang'),
            key: '2',
            children: <CustomerTab customerSegmentationId={idCheckSegment} />,
          },
          {
            label: t('segment.hoat-dong'),
            key: '3',
            children: (
              <ActivitiesTab customerSegmentationName={customerSegmentationName} customerSegmentationId={idCheckSegment} />
            ),
          },
          {
            label: t('segment.doanh-so'),
            key: '4',
            children: (
              <SalesTab customerSegmentationName={customerSegmentationName} customerSegmentationId={idCheckSegment} />
            ),
          },
        ]}
      />
    </div>
  );
}

export default observer(CustomerSegmentDetail);
